import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Form, Modal, Button, message, Spin } from 'antd';
import { userLoaded } from '../../redux/actions';
import { serverFetch } from '../../server';
import './auth.css';
import { QRCodeSVG } from 'qrcode.react';
import { getIsVkSession, getVkSession } from '../../extensions/utils';
import { MaskedInput } from 'antd-mask-input';

const Auth = ({ ...props }) => {
    const d = useDispatch();
    const { open, onClose } = props;
    const [form] = Form.useForm();
    const [signinLoading, setSigninLoading] = useState(false);
    const [signupLoading, setSignupLoading] = useState(false);
    const [authData, setAuthData] = useState({});
    const [codeSent, setCodeSent] = useState(false);
    const user = useSelector((s) => s.user);
    const [intervaled, setIntervaled] = useState();
    const [msgText, setMsgText] = useState();
    const [link, setLink] = useState();

    const [loading, setLoading] = useState(false);
    const [item, setItem] = useState({ phone: "", password: "", code: "", email: "" });
    const getExtraAuthId = () => localStorage.getItem('extraAuthId');
    const withExtraAuthId = (payload = {}) => {
        const extraAuthId = getExtraAuthId();
        return extraAuthId ? { ...payload, extraAuthId } : payload;
    };
    const onAuthSuccess = (data) => {
        localStorage.removeItem('extraAuthId');
        d(userLoaded(data));
    };

    const [part, setPart] = useState(1); // Вид формы 1 - основная, 2 - код отправлен, 3 - вход по телефону и паролю, 4 - ожидание авторизации ВК, 5 - ожидание звонка, 6 - Max
    const [codeId, setCodeId] = useState(); // ИД идентификации (после отправки кода на электронку)
    const [phoneCheckInterval, setPhoneCheckInterval] = useState(); // Интервал проверки телефонной авторизации
    
    useEffect(() => {
        user && onClose();
    }, [user]);

    useEffect(() => {
        !open && form.resetFields();
    }, [form, open]);

    const onFinish = () => {
        let data = {
            userLogin: authData.phone,
            password: authData.password,
        };
        if (authData.isSignIn) signin(data);
        else signup(data);
    };

    const signin = (data) => {
        setSigninLoading(true);
        serverFetch(`account/signin`, { method: 'POST', bodyData: data })
            .then((data) => {
                if (data) {
                    d(userLoaded(data));
                    setSigninLoading(false);
                    onClose && onClose();
                } else {
                    message.error('Ошибка авторизации');
                    setSigninLoading(false);
                }
            })
            .catch((e) => {
                setSigninLoading(false);
                e.UserMessage && message.error(e.UserMessage);
            });
    };

    const signup = (data) => {
        setSignupLoading(true);
        serverFetch(`account/signup`, { method: 'POST', bodyData: data })
            .then((data) => {
                setSignupLoading(false);
                setMsgText("Ваш пароль для входа отправлен на указанный номер телефона.");
                setCodeSent(true);
            })
            .catch((e) => {
                setSignupLoading(false);
                e.userMessage && message.error(e.userMessage);
            });
    };

    const startR = (id) => {
        const interval = setInterval(() => {
            serverFetch(`auth/vkCheck?id=${id}`, { queryParams: { extraAuthId: getExtraAuthId() } })
                .then((session) => {
                    if (session) {
                        clearInterval(interval);
                        onAuthSuccess(session);
                        onClose();
                    }
                })
                .catch(e => {
                    console.log(`Ошибка ${e.userMessage}`);
                    clearInterval(interval);
                });
          }, 1000); // Интервал 1 секунда (1000 миллисекунд)
        setIntervaled(interval)
    }

    const isVkSession = getIsVkSession();

    const openDeepLinkWithFallback = (deepLink) => {
        const timeout = 10000;
    
        const width = 800;
        const height = 300;
        const left = window.innerWidth / 2 - width / 2;
        const top = window.innerHeight / 2 - height / 2;
    
        const popup = window.open(deepLink, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
    
        setTimeout(() => {
          if (popup && !popup.closed) popup.close();
        }, timeout);
      };
    
      const startMaxLogin = () => {
        setLoading(true);
        serverFetch(`auth/VkStart?provider=max`, { method: 'GET', queryParams: { extraAuthId: getExtraAuthId() } })
          .then(data => {
            setPart(6);
            startR(data.authCode);
            setLoading(false);
            openDeepLinkWithFallback(data.url);
            setLink(data.url);
          })
          .catch(e => {
            setLoading(false);
            message.error(e.UserMessage);
          })
      }

    const startVkLogin = (provider) => {
        if (provider !== "vkid" && isVkSession) return;
        setLoading(true);
        setPart(4);
        // authvk(provider, startR);
        serverFetch(`auth/VkStart?provider=${provider}`, { queryParams: { extraAuthId: getExtraAuthId() } })
            .then(data => {
                startR(data.authCode);
                window.open(data.url, "_blank");
            })
            .catch((e) => {
                setSignupLoading(false);
                e.UserMessage && message.error(e.userMessage);
            });
    }
    
    const imgClassName = isVkSession ? 'auth-img-vk-disabled' : 'auth-img-vk-enabled';

    const onLoginPhone = () => {
        setLoading(true);
        serverFetch("auth/login", { method: "POST", bodyData: withExtraAuthId({name: item.phone.replace(/\s/g, ''), password: item.password })})
            .then(data => onAuthSuccess({ ...data }))
            .catch(e => {
                setLoading(false);
                message.error(e.userMessage);
            })
    }

    const onSendCode = () => {
        setLoading(true);
        serverFetch("auth/sendcode", { method: "POST", bodyData: withExtraAuthId({ name: item.email })})
            .then(data => {
                setCodeId(data);
                setLoading(false);
                setPart(2);
            })
            .catch(e => {
                setLoading(false);
                message.error(e.userMessage);
            })
    }

    const onLoginCode = () => {
        setLoading(true);
        serverFetch("auth/logincode", { method: "POST", bodyData: withExtraAuthId({ name: codeId, password: item.code })})
            .then(data => onAuthSuccess(data))
            .catch(e => {
                setLoading(false);
                message.error(e.userMessage);
            })
    }

    // Валидация email
    const isValidEmail = (email) => {
        if (!email) return false;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    // Валидация телефона в формате +7XXXXXXXXXX
    const isValidPhone = (phone) => {
        if (!phone) return false;
        const phoneRegex = /^\+7\d{10}$/;
        return phoneRegex.test(phone);
    }

    // Определяем тип ввода (email или телефон)
    const getInputType = (value) => {
        if (!value) return null;
        if (isValidEmail(value)) return 'email';
        if (isValidPhone(value)) return 'phone';
        return null;
    }

    // Проверка авторизации по телефону
    const checkPhoneAuth = (authCode) => {
        serverFetch(`auth/PhoneCheck?id=${authCode}`, { queryParams: { extraAuthId: getExtraAuthId() } })
            .then(data => {
                if (data) {
                    // Авторизация успешна
                    if (phoneCheckInterval) {
                        clearInterval(phoneCheckInterval);
                        setPhoneCheckInterval(null);
                    }
                    onAuthSuccess(data);
                    onClose();
                }
                // Если null - продолжаем проверку
            })
            .catch(e => {
                console.error('Ошибка проверки телефонной авторизации:', e.userMessage);
            });
    }

    // Начало процесса авторизации по телефону
    const startPhoneAuth = (phone) => {

        const encodedPhone = encodeURIComponent(phone);
        serverFetch(`auth/PhoneStart?phone=${encodedPhone}`, { queryParams: { extraAuthId: getExtraAuthId() } })
            .then(data => {
                if (data) {
                    console.log(`Начало авторизации по телефону ${data.authCode}`);
                    setPart(5);
                    // Запускаем периодическую проверку каждые 3 секунды
                    const interval = setInterval(() => { checkPhoneAuth(data.authCode); }, 3000);
                    setPhoneCheckInterval(interval);
                }
            })
            .catch(e => {
                console.error('Ошибка начала авторизации:', e.userMessage);
            });        
    }

    // Обработчик нажатия кнопки "Вход"
    const handleLogin = () => {
        const inputValue = item.email;
        const inputType = getInputType(inputValue);
        
        if (inputType === 'email') {
            // Авторизация по email (как раньше)
            onSendCode();
        } else if (inputType === 'phone') {
            // Авторизация по телефону через звонок
            startPhoneAuth(inputValue);
        }
    }

    // Проверяем, можно ли активировать кнопку "Вход"
    const isLoginButtonEnabled = () => {
        const inputValue = item.email;
        return getInputType(inputValue) !== null;
    }

    // Очистка интервала при размонтировании или закрытии
    useEffect(() => {
        return () => {
            if (phoneCheckInterval) {
                clearInterval(phoneCheckInterval);
            }
        };
    }, [phoneCheckInterval]);

    const divBody = [];

    const isMobile = false;
    console.log(part,link,isMobile)

    switch (part) {
        case 1:
            divBody.push(<div key="label" className='auth-title'>Войти или зарегистрироваться</div>);
            divBody.push(<Form.Item key="label2" name="email" label="Почта или телефон"><Input /></Form.Item>);
            divBody.push(<Form.Item key="buttons"><Button type='primary' className='auth-btn-100' onClick={handleLogin} disabled={!isLoginButtonEnabled()}>Вход</Button></Form.Item>);
            divBody.push(<Form.Item key="nets">
                    <div className='auth-btns-ss'>
                        <img src='/images/vk.svg' className='auth-img-vk-enabled' onClick={() => startVkLogin("vkid")} alt='vk'/>
                        <img src='/images/ok.svg' className={imgClassName} onClick={() => startVkLogin("ok_ru")} alt='ok'/>
                        <img src='/images/mail.svg' className={imgClassName} onClick={() => startVkLogin("mail_ru")} alt='mail'/>
                        <img src='/images/max.svg' className={imgClassName} onClick={() => startMaxLogin()} alt='max'/>
                    </div>
                </Form.Item>)
            divBody.push(<Form.Item key="label3"><div className='auth-or' onClick={() => setPart(3)}>Войти по паролю</div></Form.Item>);
            break;
        case 2:
            divBody.push(<div key="label" className='auth-title'>Войти или зарегистрироваться</div>);
            divBody.push(<Form.Item key="label2" name="email" label="Почта"><Input disabled /></Form.Item>);
            divBody.push(<Form.Item key="code" name="code" label="Код"><Input /></Form.Item>);
            divBody.push(<Form.Item key="buttons"><div className='btn-container-auth'>
                <Button className='auth-btn' size='middle' onClick={() => setPart(1)}>Назад</Button>
                <Button className='auth-btn' size='middle' onClick={onLoginCode}>Войти</Button>
                </div></Form.Item>)
            break;
        case 3:
            divBody.push(<div key="label" className='auth-title'>Вход по телефону</div>);
            divBody.push(<Form.Item key="phone" requiredMark='optional' label='Телефон' name='phone' rules={[{ required: true, message: 'Введите номер телефона' }]}>
                <MaskedInput mask={'+0 000 000 00 00'} name='phone' />
                </Form.Item>);
            divBody.push(<Form.Item key="password" label='Пароль' name='password'><Input.Password /></Form.Item>);
            divBody.push(<Form.Item key="buttons"><div className='btn-container-auth'>
                <Button className='auth-btn' size='middle' onClick={() => setPart(1)}>Назад</Button>
                <Button className='auth-btn' size='middle' onClick={onLoginPhone}>Войти</Button>
                </div></Form.Item>)
        
            break;
        case 4:
            divBody.push(<div key="label" className='auth-title'>Ожидание авторизации</div>);
            // divBody.push(<div key="wait" className='auth-waiting'><Spin /></div>)
            break;
        case 5:
            divBody.push(<div key="label" className='auth-title'>Авторизация по телефону</div>);
            divBody.push(<div key="phone-info" className='auth-phone-call-info'>
                Для авторизации позвоните по номеру{' '}
                <a href="tel:+79039250005" className='auth-phone-call-link'>+7 903 925 00 05</a>
            </div>);
            divBody.push(<Form.Item key="buttons">
                <div className='btn-container-auth'>
                    <Button className='auth-btn' size='middle' onClick={() => {
                        if (phoneCheckInterval) {
                            clearInterval(phoneCheckInterval);
                            setPhoneCheckInterval(null);
                        }
                        setPart(1);
                    }}>Назад</Button>
                </div>
            </Form.Item>);
            divBody.push(<div key="wait" className='auth-waiting'><Spin spinning/></div>);
            break;
        case 6:            
            divBody.push(<div key="wait" className='auth-waiting'><Spin spinning/></div>);
            !isMobile && link && divBody.push(<div className='auth-qr'>
                <QRCodeSVG value={link} size={180} />
                <div>Отсканируйте код на телефоне с MAX</div>
                <a href={link} target='_blank'>Открыть в браузере</a>
            </div>)
            break;
        default:                
    }

    const onValuesChange = value => setItem({...item, ...value});

    return (
        <Modal forceRender open={true} title={null} closable={false} footer={null} width={340} 
            onCancel={() => {
                setLoading(false); 
                if (intervaled) clearInterval(intervaled);
                if (phoneCheckInterval) clearInterval(phoneCheckInterval);
            }}
        >            
            <div className='logo-div'><img src='/images/logo.svg' alt='logo' className='logo-img'/></div>
            <Form colon={false} form={form} onFinish={onFinish} onValuesChange={onValuesChange} layout='vertical' disabled={loading}>
                {divBody}
                {loading && <div className='auth-waiting'><Spin spinning/></div>}      
            </Form>
        </Modal>
    );
};

export default Auth;